import { render, staticRenderFns } from "./FrontpageThemes.vue?vue&type=template&id=56d13cfe&"
import script from "./FrontpageThemes.vue?vue&type=script&lang=js&"
export * from "./FrontpageThemes.vue?vue&type=script&lang=js&"
import style0 from "./FrontpageThemes.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports